import React, { useEffect } from 'react';
import { Col, Row, Card, Button, Collapse, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
const ConcessionTable1 = require("../assets/original/Concession-Table-1.png");
const HalfFareConcessionRegional = require("../assets/original/Half-fare-concession-regional-1.png");
const ConcessionTable3 = require("../assets/original/Concession-table-3.png");
const ConcessionTable4 = require("../assets/original/Concession-table-4.png");
const SSTSStudentBusPass = require("../assets/original/SSTS_Student_Bus_Pass.png");
const WW1VeteransWidowsPass = require("../assets/original/WW1_Veterans_Widows_Pass.png");
const BlindedSoldierPass = require("../assets/original/Blinded_Soldier_Pass.png");
const ExMemberDefenceForcePass = require("../assets/original/Ex_Member_Defence_Force_Pass.png");
const VisionImpairedPersonsPass = require("../assets/original/Vision_Impaired_Persons_Pass.png");
const CompanionCard = require("../assets/original/Companion_Card.png");
const AssistanceAnimalPermit = require("../assets/original/Assistance_Animal_Permit.png");
const PensionerConcessionCard = require("../assets/original/Pensioner_Concession_Card.png");
const NSWSeniorsCard = require("../assets/original/NSW_Seniors_Card.png");
const NSWWarWidowCard = require("../assets/original/NSW_War_Widow_Card.png");
const AsylumSeekerConcessionCard = require("../assets/original/Asylum_Seeker_Concession_Card.png");
const TransportConcessionEntitlementCard = require("../assets/original/Transport_Concession_Entitlement_Card.png");
const NSWEligibleJobSeekersCard = require("../assets/original/NSW_Eligible_Job_Seekers_Card.png");
const NSWApprenticeTraineeCard = require("../assets/original/NSW_Apprentice_Trainee_Card.png");
const NSWTertiaryStudentCard = require("../assets/original/NSW_Tertiary_Student_Card.png");
const NSWACTSeniorSecondaryStudentCard = require("../assets/original/NSW_ACT_Senior_Secondary_Student_Card.png");
const PictonBuslinesStudentPass = require("../assets/original/Picton_Buslines_Student_Pass.png");
const OtherAccreditedBusOperatorStudentBusPass = require("../assets/original/Other_Accredited_Bus_Operator_Student_Bus_Pass.png");
const ProofOfAgeConcessionCard = require("../assets/original/Proof_of_Age_Concession_Card.png");
const TravelPassAndSchoolPass = require("../assets/original/Travel_Pass_and_School_Pass.png");

const concessionItems = [
  {
    key: '2',
    label: "Free Travel",
    children: <div className='TableWrap'><table border="1" cellspacing="0" cellpadding="5" className="TableList">
    <thead>
      <tr>
        <th>CONCESSION PASS</th>
        <th>ISSUER</th>
        <th>DESCRIPTION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Infants aged 0-3 accompanying their parent or guardian</td>
        <td></td>
        <td>Free Travel would not be available to say a kindergarten group accompanied by a teacher.</td>
      </tr>
      <tr>
        <td><img src={SSTSStudentBusPass} alt="SSTS Student Bus Pass" className='no-width'/></td>
        <td>Picton Buslines</td>
        <td>SSTS Student Bus Pass – For journeys to and from school or TAFE.</td>
      </tr>
      <tr>
        <td><img src={WW1VeteransWidowsPass} alt="WW1 Veterans Widows Pass" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>World War 1 Veterans Widows Pass - Free Travel if you are a permanent resident in NSW and either a widow of a WW1 veteran, 
            a recipient of the Victoria Cross or George Cross, or the spouse, widow or widower of one of these (including attendant 
            where endorsed on pass).</td>
      </tr>
      <tr>
        <td><img src={BlindedSoldierPass} alt="Blinded Soldier Pass" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>NSW Blinded Soldier Pass - Free Travel for Australian and New Zealand War Veterans classified by Department of Veterans Affairs 
            (including attendant where endorsed on pass).</td>
      </tr>
      <tr>
        <td><img src={ExMemberDefenceForcePass} alt="Ex-Member Defence Force Pass" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>Ex-Member of Defence Force Pass - Free Travel (including attendant where endorsed on Transport Concession Entitlement Card). 
            Back of Pass must display Travel Pass (ED) and be shown to driver when boarding the bus.</td>
      </tr>
      <tr>
        <td><img src={VisionImpairedPersonsPass} alt="Vision Impaired Persons Pass" className='no-width'/></td>
        <td>Transport for NSW Concessions Office and equivalent transport agency in other States and Territories</td>
        <td>Vision Impaired Persons Pass (NSW and Interstate) - Free Travel including guide dog. Attendant Travels Free when endorsed on pass.</td>
      </tr>
      <tr>
        <td><img src={CompanionCard} alt="Companion Card" className='no-width'/></td>
        <td>Department of Family and Community Services and equivalent agencies in other States and Territories</td>
        <td>Companion Card - Free Travel for Attendant.</td>
      </tr>
      <tr>
        <td><img src={AssistanceAnimalPermit} alt="Assistance Animal Permit" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>Assistance Animal Permit - Assistance Animal Travels for Free. NSW Permit essential for everyone except those using 
            an accredited Guide Dog or Hearing Dog.</td>
      </tr>
    </tbody>
  </table></div>
  },
  {
    key: '3',
    label: "Half Fare Concession & Regional Excursion Daily (RED)",
    children: <div className='TableWrap'><table border="1" cellspacing="0" cellpadding="5" className="TableList">
    <thead>
      <tr>
        <th>CONCESSION PASS</th>
        <th>ISSUER</th>
        <th>DESCRIPTION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{minWidth: '190px'}}><img src={PensionerConcessionCard} alt="Pensioner Concession Card" className='no-width'/></td>
        <td>Department of Human Services or Department of Veteran Affairs</td>
        <td>
          Pensioner Concession Card. Half Fare for Single Tickets or $2.50 for RED.  
          Only valid for card holder, family members on back of pass pay full fare.  
          Digital Wallets are accepted as proof of entitlement.  
          Front and back of card must be shown.
        </td>
      </tr>
      <tr>
        <td><img src={NSWSeniorsCard} alt="NSW Seniors Card" className='no-width'/></td>
        <td>Department of Human Services</td>
        <td>
          NSW Seniors Card. Half Fare for Single Tickets or $2.50 for RED.  
          Seniors Card Holders from Other States and Territories - Half Fare Only.
        </td>
      </tr>
      <tr>
        <td><img src={NSWWarWidowCard} alt="NSW War Widow Card" className='no-width'/></td>
        <td>Department of Veterans Affairs</td>
        <td>
          NSW War Widow/er. Half Fare for Single Tickets or $2.50 for RED.
        </td>
      </tr>
      <tr>
        <td><img src={AsylumSeekerConcessionCard} alt="Asylum Seeker Concession Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          Asylum Seekers. Half Fare for Single Tickets or $2.50 for RED.  
          Back of pass must display Senior/Pensioner (CG) and be shown when boarding the bus.
        </td>
      </tr>
    </tbody>
  </table></div>
  },
  {
    key: '4',
    label: "Half Fare Concession (Ages 16 and over)",
    children: <div className='TableWrap'><table border="1" cellspacing="0" cellpadding="5" className="TableList">
    <thead>
      <tr>
        <th>CONCESSION PASS</th>
        <th>ISSUER</th>
        <th>DESCRIPTION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{minWidth: '190px'}}><img src={TransportConcessionEntitlementCard} alt="Transport Concession Entitlement Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          Transport Concession Entitlement Card for NSW Job Seekers / Apprentice / Trainee / NSW Tertiary Student.  
          Refer to more information below.
        </td>
      </tr>
      <tr>
        <td><img src={NSWEligibleJobSeekersCard} alt="NSW Eligible Job Seekers Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          NSW Eligible Job Seekers and those receiving approved Centrelink Benefits are entitled to concession fares.  
          Half Fare for Single Tickets.  
          Back of pass must display Concession (CG) and must be shown to driver when boarding the bus.
        </td>
      </tr>
      <tr>
        <td><img src={NSWApprenticeTraineeCard} alt="NSW Apprentice/Trainee Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          NSW Apprentice / Trainee – Card is valid up to 31 March of each year.  
          Can be renewed free of charge as long as Apprentice/Trainee remains in an active traineeship/apprenticeship approved by Training Services NSW.  
          Back of pass must display Concession (AT) and must be shown to the driver when boarding the bus.
        </td>
      </tr>
      <tr>
        <td><img src={NSWTertiaryStudentCard} alt="NSW Tertiary Student Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          NSW Tertiary Student – This card is available to students who meet the eligibility criteria set by Transport for NSW.  
          Valid for up to 15 months if student remains eligible. Card must be renewed by 31 March each year.  
          Back of pass must display Concession (TS) and must be shown to the driver when boarding the bus.
        </td>
      </tr>
      <tr>
        <td><img src={NSWACTSeniorSecondaryStudentCard} alt="NSW/ACT Senior Secondary Student Card" className='no-width'/></td>
        <td>Transport for NSW Concessions Office</td>
        <td>
          NSW/ACT Senior Secondary Student – This card is available to senior secondary students who meet the eligibility criteria set by Transport for NSW.  
          It is valid until 31 March the following year unless you enter full-time employment.
        </td>
      </tr>
      <tr>
        <td><img src={PictonBuslinesStudentPass} alt="Picton Buslines Student Pass" className='no-width'/></td>
        <td>Picton Buslines</td>
        <td>Half Fare Concession for journeys other than to and from school.</td>
      </tr>
      <tr>
        <td><img src={OtherAccreditedBusOperatorStudentBusPass} alt="Other Accredited Bus Operator Student Bus Pass" className='no-width'/></td>
        <td>Other Accredited Bus Operator Student Bus Pass</td>
        <td>Half Fare Concession is payable.</td>
      </tr>
    </tbody>
  </table></div>
  },
  {
    key: '5',
    label: "Half Fare (Ages 4 - 15 inclusive)",
    children: <div className='TableWrap'><table border="1" cellspacing="0" cellpadding="5" className="TableList">
    <thead>
      <tr>
        <th>CONCESSION PASS</th>
        <th>ISSUER</th>
        <th>DESCRIPTION</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{minWidth: '190px'}}>
          <img src={ProofOfAgeConcessionCard} alt="Proof of Age Concession Card" className='no-width'/>
        </td>
        <td>Transport for NSW Concessions Office</td>
        <td>Card will show the expiry date of entitlement. This card cannot be used for non-transport purposes.</td>
      </tr>
      <tr>
        <td>
          <img src={TravelPassAndSchoolPass} alt="Travel Pass and School Pass" className='no-width'/>
        </td>
        <td>Any accredited bus operator</td>
        <td>For journeys other than to and from school, half fare is payable.</td>
      </tr>
    </tbody>
  </table></div>
  }
];

const faqGeneralItems = [
  {
    key: '1',
    label: "What is the new ticketing system?",
    children: <p>It's a modern, cashless, distance-based ticketing system that lets you pay your bus fare by tapping on and tapping off with a contactless debit/credit card, or digital wallet (phone or smart device).</p>
  },
  {
    key: '2',
    label: "Why is Picton Buslines introducing this new system?",
    children: <p>We're introducing the new system to provide distance-based fares, faster boarding, and more convenient payment options for our growing community.</p>
  },
  {
    key: '3',
    label: "When will the new system start?",
    children: (
      <div>
        <ul>
          <li><div><strong>Phase 1 (from Monday 27 October 2025):</strong> Tap on/tap off goes live. Cash ticket machines will remain available.</div></li>
          <li><div><strong>Phase 2 (from Monday 16 February 2026):</strong> Cash ticket machines will be removed. All payments must be made using the new system.</div></li>
        </ul>
      </div>
    )
  }
];

const faqHowItWorksItems = [
  {
    key: '1',
    label: "How do I use the system?",
    children: (
      <div>
        <ol>
          <li>Tap on when you board using your contactless debit/credit card or digital wallet.</li>
          <li>Tap off with the same card or device when you exit.</li>
        </ol>
      </div>
    )
  },
  {
    key: '2',
    label: "Do I need to tap off? What happens I forget to?",
    children: <p>Yes. Tapping off ensures your fare is calculated correctly. If you forget, the system will apply the maximum default fare for that route.</p>
  },
  {
    key: '3',
    label: "Can I use my phone or smartwatch?",
    children: <p>Yes. Any device with a linked digital wallet (Apple Pay, Google Pay, Samsung Pay, etc.) will work.</p>
  },
  {
    key: '4',
    label: "What happens if I forget to tap on?",
    children: <p>If you don't tap on, your trip won't be registered. Drivers are not able to manually log trips for you. Please always tap on at the start of your journey.</p>
  },
  {
    key: '5',
    label: "What if I use different cards or devices to tap on and tap off?",
    children: <p>The system won't recognise it as the same trip. Always use the same card or device to tap on and tap off.</p>
  }
];

const faqPaymentsItems = [
  {
    key: '1',
    label: "How are fares calculated?",
    children: <p>Fares are straight line distance-based, meaning you pay for the exact distance travelled between your tap on and tap off locations. Your fares will not change from how they are currently calculated. They are in line with the IPART Rural and Regional fare scale, as they have always been.</p>
  },
  {
    key: '2',
    label: "When is payment taken?",
    children: <p>Trips are aggregated, and payments are processed securely at the end of the day. You'll see a single charge on your account.</p>
  },
  {
    key: '3',
    label: "What happens if I don't have enough money in my account?",
    children: (
      <div>
        <p>You may be able to tap on the first time you use your card, but the tap off will be declined, as will subsequent taps. Your card will blocked from travelling until the payments have cleared.</p>
        <p>Once adequate funds have been added to your card:</p>
        <ol>
          <li>Overnight we will try to settle any outstanding debt, if successful your card will automatically be unblocked</li>
          <li>Tap your card, it will initially fail, however it will then try to settle any outstanding debt, if successful your card will be unblocked within 2-5 minutes</li>
        </ol>
      </div>
    )
  },
  {
    key: '4',
    label: "How can I view a history of my transactions?",
    children: <p>You will have a record of your trip on your bank statement, you can also visit <a href="https://customer.tikpay.me" target="_blank" rel="noopener noreferrer">https://customer.tikpay.me</a> and enter your details to receive more trip information.</p>
  },
  {
    key: '5',
    label: "What if I am travelling with children and need to pay for them on the same card?",
    children: <p>The bus driver has the ability to issue a multi ticket for more than one traveller who are travelling together on one debit/credit card. Simply speak to the driver and they can assist you.</p>
  },
  {
    key: '6',
    label: "Will my daily or weekly fares be capped?",
    children: <p>Fares will automatically be capped if travel exceeds the adult ticket fare. These are outlined in the IPART Rural and Regional fare scale.</p>
  },
  {
    key: '7',
    label: "Can I still pay with cash?",
    children: <p>You cannot pay cash on the bus after Phase 2. However, you can load trips onto a <strong>Picton Buslines Travel Card</strong> with cash at our depot. You will not be charged to purchase the card, only to load trips onto the card itself.</p>
  },
  {
    key: '8',
    label: "What is a Picton Buslines Travel Card?",
    children: <p>It's a prepaid card that works the same way as a contactless card on the bus. You can load credit at the depot with cash. You will not be charged to purchase the card.</p>
  }
];

const faqConcessionsItems = [
  {
    key: '1',
    label: "How do concession fares work?",
    children: <p>Register your concession card once (with the driver on your first trip or at the depot), and it will be linked to your account. Your discounted fare will automatically apply each time you travel.</p>
  },
  {
    key: '2',
    label: "Do I need to carry my concession card?",
    children: <p>Yes. You will be asked to show your concession card as proof of entitlement.</p>
  },
  {
    key: '3',
    label: "Can I use a school student bus pass?",
    children: <p>Yes. School student free travel passes remain valid for eligible students. They are separate from the new cashless system.</p>
  },
  {
    key: '4',
    label: "Which discounts and concession will apply?",
    children: <p>These remain the same as is currently in place. All discounts are those allowable under the IPART Rural and Regional Fare Scale.</p>
  }
];

const faqTechnicalItems = [
  {
    key: '1',
    label: "Is my payment secure?",
    children: <p>Yes. Payments are processed by <strong>Tikpay</strong> and securely backed by <strong>Westpac</strong>, using the same protections as other contactless payments.</p>
  },
  {
    key: '2',
    label: "Will drivers or Picton Buslines staff see my card details?",
    children: <p>No. Card details are never shared with Picton Buslines. We only see trip and fare information to help with customer support.</p>
  },
  {
    key: '3',
    label: "Can I get a receipt for my trips?",
    children: <p>Yes. You can register for an online account to view your trip history, fares, and payments.</p>
  }
];

const faqTransitionItems = [
  {
    key: '1',
    label: "Will drivers help me during the changeover?",
    children: <p>Yes. Our drivers and depot staff will assist during the transition to ensure everyone understands how to use the new system.</p>
  },
  {
    key: '2',
    label: "What if I don't want to use a debit or credit card?",
    children: <p>You can use the Picton Buslines Travel Card, which can be topped up with cash at our depot.</p>
  },
  {
    key: '3',
    label: "Will the cash option ever come back on the bus?",
    children: <p>No. After December 2025, buses will operate on a cashless-only basis for efficiency and safety.</p>
  }
];

const faqSupportItems = [
  {
    key: '1',
    label: "What if I forget to tap off and get charged more?",
    children: <p>Contact Picton Buslines. We can review your trip history and adjust your fare if appropriate.</p>
  },
  {
    key: '2',
    label: "Who do I contact if there's an issue with my payment?",
    children: <p>Please contact our customer service team at (02) 4677 1564 or visit the depot. We can access your trip and payment history to help resolve any issues.</p>
  },
  {
    key: '3',
    label: "What if I lose my Picton Buslines Travel Card?",
    children: <p>Contact us immediately. We can cancel your card and transfer any remaining balance to a new one.</p>
  },
  {
    key: '4',
    label: "Where can I get more information?",
    children: (
      <div>
        <ul>
          <li>Visit our website for updates.</li>
          <li>Call our office on (02) 4677 1564.</li>
          <li>Visit the depot in person, 18 Wonga Road Picton</li>
        </ul>
      </div>
    )
  }
];

export default function TicketingAndFares() {
  useEffect(() => {
    document.body.classList.add("PageStudentTravel");
    return () => {
      document.body.classList.remove("PageStudentTravel");
    };
  }, []);
  return (
    <div className="StudentTravel PageSingle" style={{paddingBottom: "50px"}}>
      <section className="PageHero">
        <div className="AppContainer">
          <h1 className="title">TICKETING AND FARES</h1>
        </div>
      </section>
      <div className="AppContainer">
        <Row gutter={[20, 0]}>
          <Col xs={{span: 24, order: 2}} md={{span: 24, order: 1}}>
            <Card bordered={false} className="CardItem mb-25">
              <p>In response to the evolving needs of our community, Picton Buslines is proud to introduce a new, modern way to pay for your bus travel. We have recognised that our changing demographics demand a more efficient and modern form of payment. To meet this need, we have partnered with two innovative Australian start-ups, <strong><a href="https://www.tikpay.com" target="_blank" rel="noopener noreferrer">Tikpay</a></strong> and <strong><a href="https://busable.app" target="_blank" rel="noopener noreferrer">Busable</a></strong>, to develop a new state-of-the-art cashless ticketing system.</p>
              {/* <p>This innovative approach uses a <strong>distance-based fare</strong> system, ensuring that your fare is calculated accurately based on the length of your trip. This provides a fair and transparent payment structure for every journey.</p> */}
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">How Does It Work?</h2>
              <p style={{marginBottom: '20px'}}>It's easy!</p>
              <ul>
                <li><div><strong>Tap on</strong> when you board the bus using your contactless debit/credit card or a linked digital wallet on your phone or smart device.</div></li>
                <li><div><strong>Tap off</strong> with the same card or device when you exit the bus.</div></li>
              </ul>
              <p>The system automatically matches your taps, calculates the correct fare, applies any concessions or discounts, and aggregates your trips into a single secure payment.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">When Is It Going Live?</h2>
              <ul>
                <li><div><strong>Phase 1: Monday, October 27, 2025 -</strong> The new tap on/tap off system will go live. For this initial phase, our current cash ticket machines will remain active to help with the transition.</div></li>
                <li><div><strong>Phase 2: Monday, February 16, 2026 -</strong> The current cash ticket machines will be removed from the buses. From this date on, the cashless ticketing system will be fully live.</div></li>
              </ul>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">What If I Don't Have a Credit or Debit Card?</h2>
              <p>No problem. You can still pay with cash at the Picton Buslines depot, where our team can load credit onto a Picton Buslines Travel Card for you. This card works just like a contactless card on the bus.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">What about Concession Card Holders?</h2>
              <p>Register once, and you're set.</p>
              <ul>
                <li>Show your concession card to the driver the first time you travel, and it will be securely linked to your account.</li>
                <li>Alternatively, visit the Picton Buslines depot to register your concession card.</li>
              </ul>
              <p>After registering, your concession will automatically apply every time you travel.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Is This Part of the Opal Network?</h2>
              <p>No. This new system is entirely separate from the Opal network. Picton Buslines is not part of the Opal network, and as such, Opal cards are <strong>not</strong> accepted on our services. This system is not implemented or supported by TfNSW.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">How Do I Know My Card Details Are Safe?</h2>
              <p className="not-last">Your security is our top priority.</p>
              <ul>
                <li><div>The system is developed and managed by <strong>Tikpay</strong>, a trusted ticketing provider already operating in cities across Australia.</div></li>
                <li><div>Payments are securely processed and backed by <strong>Westpac</strong>, using the same protections as other contactless transactions.</div></li>
              </ul>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">What Are the Benefits?</h2>
              <ul>
                <li><div><strong>Distance Based:</strong> As outlined in the IPART Rural and Regional fare scale.</div></li>
                <li><div><strong>Fast and Easy:</strong> No need to search for cash or wait for change. Just tap and go.</div></li>
                <li><div><strong>Convenient:</strong> Use a payment method you already have and use every day.</div></li>
                <li><div><strong>Secure:</strong> All transactions are protected with the same security features as other contactless payments.</div></li>
              </ul>
              <p>We are committed to making your travel experience as smooth as possible. We are proud to bring this state-of-the-art technology to our local community.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">We're Here to Help</h2>
              <p>We know this is a big change, and our team is ready to make the transition as smooth as possible. If you have questions about your travel, payments, or account, contact us directly. Our team has full access to trip and payment details and is here to assist.</p>
              <p>For more detailed information, please visit our <strong><a href="#faq">Frequently Asked Questions (FAQ) Page.</a></strong></p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Fares and Concessions</h2>
              <p>Picton Buslines ticketing system is GPS enabled and automatically calculates the direct distance-based fare. Fares are charged in accordance with the IPART Rural and Regional Bus Services fares.</p>
              
              <h3 className="CardTitle">Maximum Fares for Single Journey Tickets for Rural and Regional Bus Services</h3>
              <div className="TableWrap mb-40">
                <table width="100%" className="TableList">
                  <thead>
                  <tr>
                  <th align="left">Number of KM's Transversed</th>
                  <th align="left">Maximum Fare ($)</th>
                  <th align="left">Concession Fare ($)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <td align="left">0 to ≤ 3</td>
                  <td align="left">$2.30</td>
                  <td align="left">$1.10</td>
                  </tr>
                  <tr>
                  <td align="left">{'>'} 3 to ≤ 8</td>
                  <td align="left">$3.30</td>
                  <td align="left">$1.60</td>
                  </tr>
                  <tr>
                  <td align="left">{'>'} 8 to ≤ 20</td>
                  <td align="left">$4.20</td>
                  <td align="left">$2.10</td>
                  </tr>
                  <tr>
                  <td align="left">{'>'} 20 to ≤ 35</td>
                  <td align="left">$4.50</td>
                  <td align="left">$2.20</td>
                  </tr>
                  <tr>
                  <td align="left">{'>'} 35 to ≤ 65</td>
                  <td align="left">$5.90</td>
                  <td align="left">$2.90</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <p>Eligible concession card holders are entitled to the appropriate concession fare. The Picton Buslines ticketing system will automatically calculate this fare, if your payment card is registered as eligible for concessions.</p>
              <p>Register your concession card once (with the driver on your first trip or at the depot), and it will be linked to your card.</p>
            </Card>

            <Card bordered={false} className="CardItem mb-25">
              <h2 className="CardTitle">Concession Passes</h2>
              <Collapse accordion items={concessionItems} size="large" />
            </Card>

            <Card bordered={false} className="CardItem mb-25" id="faq">
              <h2 className="CardTitle">Frequently Asked Questions - Cashless Tap On / Tap Off Ticketing</h2>
              
              <h3 className="CardTitle">GENERAL</h3>
              <Collapse accordion items={faqGeneralItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>HOW IT WORKS</h3>
              <Collapse accordion items={faqHowItWorksItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>PAYMENTS AND FARES</h3>
              <Collapse accordion items={faqPaymentsItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>CONCESSIONS</h3>
              <Collapse accordion items={faqConcessionsItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>TECHNICAL AND SECURITY</h3>
              <Collapse accordion items={faqTechnicalItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>TRANSITION PERIOD</h3>
              <Collapse accordion items={faqTransitionItems} size="large" className="mb-20" />
              
              <h3 className="CardTitle" style={{marginTop: '30px'}}>SUPPORT</h3>
              <Collapse accordion items={faqSupportItems} size="large" />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
